/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Uygulama kabuğundaki sabit bölüm sırasını ürün manifestlerinin kayıt
 * sırasından ayırır. Ürün bölümlerinin kendi aralarındaki sırası korunur.
 */
export function orderSidebarSections<T extends { id: string }>(sections: readonly T[]): T[] {
    const dashboardSections: T[] = [];
    const productSections: T[] = [];
    const settingsSections: T[] = [];

    for (const section of sections) {
        if (section.id === 'dashboard') {
            dashboardSections.push(section);
        } else if (section.id === 'settings') {
            settingsSections.push(section);
        } else {
            productSections.push(section);
        }
    }

    return [...dashboardSections, ...productSections, ...settingsSections];
}
